export default "__VITE_ASSET__vc_3R6MO__"